<template>
  <div>
    <via-nav-bar
      title="制作图标"
      @click-left="$router.$back()"
    />
    <div
      class="content"
      :style="{ height: $vw(contentHeight - 92) }"
    >
      <div
        class="icon-box"
        :style="{backgroundColor:iconBgColor}"
      >
        <van-icon
          class="icon"
          :size="$vw('50px')"
          class-prefix="icon"
          :color="iconColor || 'var(--light40)'"
          :name="icon"
        />
      </div>
      <van-button
        class="btn"
        plain
        type="primary"
        @click="selectIcon"
      >选择图标</van-button>
      <van-button
        class="btn"
        plain
        type="primary"
        @click="selectColor"
      >选择图标颜色</van-button>
      <van-button
        class="btn"
        type="primary"
        @click="confirm"
      >确认完成</van-button>

      <van-popup
        v-model="showColorPicker"
        position="left"
        :style="{ height: documentHeight + 'px' }"
      >
        <div class="popup-box">
          <chrome-picker v-model="colors" />
          <van-button
            class="popup-box-btn"
            type="primary"
            :plain="!iconColor"
            :color="iconColor"
            @click="setColor"
          >设为图标颜色</van-button>
          <van-button
            class="popup-box-btn"
            type="primary"
            :plain="!iconBgColor"
            :color="iconBgColor"
            @click="setBgColor"
          >设为图标背景色</van-button>
        </div>
      </van-popup>

      <van-popup
        v-model="showIconPicker"
        position="left"
        :style="{ height: documentHeight + 'px' }"
      >
        <via-icon-select
          :width="200"
          :clear="showIconPicker"
          @click="setIcon"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import chrome from 'vue-color/src/components/Chrome'
import { Button, Popup } from 'vant'
import ViaIconSelect from 'components/common/via-icon-select'

export default {
  name: 'MakeIcon',
  components: {
    'chrome-picker': chrome,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [ViaIconSelect.name]: ViaIconSelect
  },
  data() {
    return {
      icon: '',
      iconColor: '',
      iconBgColor: '',
      colors: {},
      showColorPicker: false,
      showIconPicker: false
    }
  },
  computed: {
    // rpx
    contentHeight() {
      return this.$pxToRpx(this.$clientHeight) - 46
    },
    // px
    documentHeight() {
      return this.$clientHeight
    }
  },
  activated() {
    this.initData()
  },
  methods: {
    initData() {
      const data = this.$store.getters['makeIcon/data']
      const key = this.$route.params.storeKey || 'default'
      if (data[key]) {
        const { icon, iconBgColor, iconColor } = data[key]
        this.icon = icon
        this.iconColor = iconColor
        this.iconBgColor = iconBgColor
      }
    },
    selectColor() {
      this.showColorPicker = true
    },
    selectIcon() {
      this.showIconPicker = true
    },
    setColor() {
      if (!this.colors.hex && this.iconColor && this.iconBgColor) {
        this.showColorPicker = false
        return
      }
      if (!this.colors.hex) {
        this.$toast.fail('请先在调色板选择颜色')
        return
      }
      this.iconColor = this.colors.hex
    },
    setBgColor() {
      if (!this.colors.hex && this.iconColor && this.iconBgColor) {
        this.showColorPicker = false
        return
      }
      if (!this.colors.hex) {
        this.$toast.fail('请先在调色板选择颜色')
        return
      }
      this.iconBgColor = this.colors.hex
    },
    setIcon(e) {
      const { name } = e
      this.icon = name
      this.showIconPicker = false
    },
    confirm() {
      const [icon, iconColor, iconBgColor] = [this.icon, this.iconColor, this.iconBgColor]
      if (!icon) {
        this.$toast.fail('你还没选择图标')
        return
      }
      if (!iconColor) {
        this.$toast.fail('你还没选择图标颜色')
        return
      }
      if (!iconBgColor) {
        this.$toast.fail('你还没选择图标背景色')
        return
      }
      const key = this.$route.params.storeKey || 'default'
      this.$store.commit('makeIcon/updateData', { ...this.$store.getters['makeIcon/data'], [key]: { icon, iconColor, iconBgColor }})
      this.$router.$back()
    }
  }
}
</script>

<style scoped>
.content {
  width: 375px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.icon-box {
  width: 80px;
  height: 80px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(--boxShadow-bottom);
  margin-bottom: 30px;
}
.btn {
  width: 250px;
  border-radius: 15px;
  margin-top: 15px;
}
.popup-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.popup-box-btn {
  width: 200px;
  height: 40px;
  border-radius: 15px;
  margin-top: 30px;
  box-shadow: var(--boxShadow-bottom);
}
</style>
<style>
.vc-chrome {
  box-shadow: none !important;
}
</style>
